import axios from 'axios'
import Vue from 'vue'

let axiosPlugin = {}
axios.interceptors.response.use(function (response) {
    let {data, status} = response
    let res = {data: data, status: status}
    return res
}, function (error) {
    // 对响应错误做点什么
    console.log(error)
    return Promise.reject(error)
})
axiosPlugin.install = function () {
    Vue.prototype.$axios = function (obj, base) {
        let API_BASE_URL = base || process.env.API_BASE
        let spRule = /^http/
        axios.interceptors.request.use(function (config) {
            let {url} = config
            if (!url.match(spRule)) {
                config.url = API_BASE_URL + url
            }
            return config
        })
        return axios(obj)
    }
}
export default axiosPlugin



// WEBPACK FOOTER //
// ./src/lib/api.js